<ngx-spinner [name]="'relatorio-estoque'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Relatório de estoque</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>

        <div class="row">
            <div class="col-2">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>Tipo de busca</mat-label>
                    <mat-select [(ngModel)]="sbBuscaTipoRelatorio">
                        <mat-option *ngFor="let tipo of aTipoTipoBuscaRelatorio" [value]="tipo.value">
                            {{tipo.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-auto">
                <button class="mt-4" mat-flat-button color="primary" (click)="gerarRelatorio()">
                    <mat-icon>search</mat-icon> Gerar relatório
                </button>
            </div>
        </div>


        <div class="row mt-2" *ngIf="bExportar">
            <div class="col-sm">
                <mat-divider></mat-divider>

                <div class="row mt-2">
                    <div class="col-sm text-right">
                        <button mat-flat-button color="warn" (click)="exportar()">
                            <mat-icon>print</mat-icon> Exportar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>